import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SubscriptionComponent } from '@app2/features/subscription/subscription.component';
import { AnalystService } from '@app/services/analyst/analyst.service';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';

@Component({
  selector: 'sens-subscribe-modal',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SubscriptionComponent,
  ],
  templateUrl: './subscribe-modal.component.html',
  styleUrl: './subscribe-modal.component.scss',
})
export class SubscribeModalComponent {
  private dialogRef = inject(DynamicDialogRef);

  private analystService = inject(AnalystService);

  onClose(): void {
    this.analystService.logEvent(AnalyticsEventsEnum.SubscribeModalCloseTap).then();
    this.dialogRef.close();
  }
}
